
<div [formGroup]="form" *ngIf="form">

	<div class="d-flex v-align">
		<span class="mat-caption">Check all that apply.</span>
		<mat-checkbox color="primary" formControlName="casePreferenceAdvanceFees" aria-label="Advance Fees">Advance Fees</mat-checkbox>
		<mat-checkbox color="primary" formControlName="casePreferenceAlwaysDeliverCourtesyFeesBack" aria-label="Please deliver courtesy copy">Please deliver courtesy copy</mat-checkbox>
	</div>

</div>